import { render, staticRenderFns } from "./accidentDetail.vue?vue&type=template&id=55728188&scoped=true&"
import script from "./accidentDetail.vue?vue&type=script&lang=js&"
export * from "./accidentDetail.vue?vue&type=script&lang=js&"
import style0 from "./accidentDetail.vue?vue&type=style&index=0&id=55728188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55728188",
  null
  
)

export default component.exports